<template lang="html">
<div class="pgInner affairEdit">

    <div class="headBar">团队库</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
        <el-scrollbar ref="scroller" style="height:100%;">
            <!-- <div class="tabNavs" ref="tabNavs">
                <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
                    {{item}}
                </div>
                <div class="moveLine" :style="lineStr"></div>
            </div> -->
            <tab-navs v-model="navAct" ref="tabNavs" :navs="navs" />
            <div class="tabContent">
                <Subpage1 @inited="readyHandle" :indata="param.dto" ref="Subpage1" v-show="navAct===0" />
                <Subpage2 @inited="readyHandle" :indata="param.dto" ref="Subpage2" v-show="navAct===1" />
                <Subpage3 @inited="readyHandle" :indata="param.dto" ref="Subpage3" v-show="navAct===2" />
            </div>
        </el-scrollbar>
    </div>

    <div class="pagefoot">

        <div v-if="pgState" class="loading">
            <span v-if="pgState == 1">初始化中...</span>
            <span v-if="pgState == 2">数据保存中...</span>
            <i class="el-icon-loading"></i>
        </div>
        <div v-else>
            <el-button @click="goSave()" type="primary" size="small">保存</el-button>
            <el-button @click="goReturn" size="small">返回</el-button>
        </div>

    </div>

</div>
</template>

<script>
import {
    updateTeamDTO,
    getTeamDTOById
} from '@/api/jingshi';

import Subpage1 from "./src/subpage1";
import Subpage2 from "./src/subpage2";
import Subpage3 from "./src/subpage3";
export default {
    components: {
        Subpage1,
        Subpage2,
        Subpage3,
    },
    computed: {
        lineStr: function () {
            var str = 'width:60px;';
            str = str + "left:" + this.navX + "px;";
            return str;
        },
        pgState: function () {
            var state = 0;
            if (this.id && this.readyKey !== 3) {
                state = 1;
            }

            if (this.uploadIng) {
                state = 2;
            }

            return state;
        }
    },
    data() {
        return {
            id: '',
            navs: ['主页信息', '成员管理', '其他设置'],
            navAct: 0,
            navX: 15,
            pageH: '',
            readyKey: 0,
            uploadIng: false,

            param: {
                dto: {
                    id: '',
                    name: '', //团队名称
                    majorId: '', //专业领域ID<多选>
                    major: '', //专业领域
                    cellphone: '', //咨询电话
                    introduce: '', //介绍
                    homeChart: '', //主页图
                    lawyerSocialaccountsList: [], //社交账号
                    status: 0, //律师成员

                    fuzerenList: [],
                    lawyerTeamList: [],

                    seoKeyword: '',
                    seoTitle: '',
                    seoDesc: '',
                    seoDesc: '',
                    views: 0, // 内容
                    modelLink: '', // 无权限1 有权限2
                    customLink: '', // 无权限1 有权限2
                }
            }
        }
    },

    methods: {
        // 保存
        save() {
            var vues = this;
            this.param.dto.class_type = "TJingshiTeam";
            console.log(this.param);
            updateTeamDTO(this.param).then(res => {
                console.log(res);
                this.$message.success('保存成功！');
                vues.goReturn();
            })
        },
        goSave() {
            var vues = this;

            console.log(this.$refs);

            var wait1 = this.$refs.Subpage1.saveReturn();
            wait1.then(data => {
                if (data) {
                    for (let key in data) {
                        if (vues.param.dto.hasOwnProperty(key)) {
                            vues.param.dto[key] = data[key];
                        }
                    }
                    var wait2 = this.$refs.Subpage2.saveReturn();
                    wait2.then(data => {
                        if (data) {
                            for (let key in data) {
                                if (vues.param.dto.hasOwnProperty(key)) {
                                    vues.param.dto[key] = data[key];
                                }
                            }
                            var wait3 = this.$refs.Subpage3.saveReturn();
                            wait3.then(data => {
                                if (data) {
                                    for (let key in data) {
                                        if (vues.param.dto.hasOwnProperty(key)) {
                                            vues.param.dto[key] = data[key];
                                        }
                                    }
                                    vues.save();
                                } else {
                                    this.$refs.tabNavs.setNavAct(2);
                                }
                            });
                        } else {
                            this.$refs.tabNavs.setNavAct(1);
                        }
                    });

                } else {
                    this.$refs.tabNavs.setNavAct(0);
                }
            });

        },

        goReturn: function () {
            this.$router.go(-1);
        },
        tabChange: function (e, inx) {
            // var tabNavs = this.$refs.tabNavs;
            this.navAct = inx;
            this.navX = e.target.offsetLeft;
        },

        pageFix: function () {
            this.pageH = document.documentElement.clientHeight - 205;
        },

        readyHandle: function () {
            this.readyKey++;
        },
        getDto: function () {
            var req = {
                id: this.param.dto.id,
            }
            getTeamDTOById(req).then(res => {
                this.param.dto = res.dto;
            });
        }
    },

    created: function () {
        var vues = this;
        var querys = this.$route.query;
        this.param.dto.type = querys.type;
        // if (this.param.dto.type == 2) {
        //     this.navs = ['基本信息', '成员管理', '其他设置'];
        // }
        if (querys.id) {
            this.param.dto.id = querys.id;
            this.getDto();
        }

        $(window).resize(function () {
            vues.pageFix();
        })
    }
}
</script>

<style lang="scss" scoped>
.pgInner {
    background: #f5f5f5;
}

.headBar {
    height: 55px;
    line-height: 55px;
    font-size: 16px;
    padding-left: 20px;
    background: white;
}

.tabNavs {
    height: 50px;
    padding-left: 15px;
    background: white;
    position: relative;

    .tabItem {
        float: left;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        margin-right: 45px;
        cursor: pointer;
    }

    .tabItem.act {
        color: rgb(86, 119, 252);
    }

    .moveLine {
        height: 2px;
        background: rgb(86, 119, 252);
        position: absolute;
        bottom: 0px;

        transition-property: all;
        transition-duration: 0.2s;
    }
}

.tabContent {
    padding: 20px;
    background: white;
}

.pagefoot {
    height: 60px;
    line-height: 60px;
    background: white;
    padding-left: 20px;
    position: relative;
    z-index: 2;

    .btn {
        height: 32px;
        padding: 0 12px;
        margin-right: 12px;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
    }

    .type1 {
        line-height: 32px;
        background: rgb(86, 119, 252);
        color: white;
    }

    .type2 {
        box-sizing: border-box;
        border: 1px solid #aeaeae;
        line-height: 30px;
    }

    .loading {
        font-size: 14px;
        padding-left: 24px;
        color: #aeaeae;

        i {
            font-size: 18px;
            vertical-align: middle;
        }
    }
}
</style>

<style lang="css">
.affairEdit .pgbody {
    margin: 20px;
    background: white;
}

@media only screen and (max-width: 1366px) {
    .affairEdit .pgbody {
        margin: 10px 0;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?738578ea